/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_DeleteInputs */

const en_us2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete gym`)
};

const pt_br2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir academia`)
};

const es_419_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar gimnasio`)
};

const pt_pt2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar ginásio`)
};

const fr_fr2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer la salle`)
};

const de_de2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Studio löschen`)
};

const it_it2_gyms_delete = /** @type {(inputs: Gyms_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina palestra`)
};

/**
* | output |
* | --- |
* | "Delete gym" |
*
* @param {Gyms_DeleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_delete = /** @type {((inputs?: Gyms_DeleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_DeleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_delete(inputs)
	if (locale === "es-419") return es_419_gyms_delete(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_delete(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_delete(inputs)
	if (locale === "de-DE") return de_de2_gyms_delete(inputs)
	if (locale === "it-IT") return it_it2_gyms_delete(inputs)
	return en_us2_gyms_delete(inputs)
});
export { gyms_delete as "gyms.delete" }